<script lang="ts" setup>
import { useCountdown } from "~/composables/local/counter"

const props = defineProps<{
	phoneLoading: boolean
	googleLoading: boolean
	codeLoading: boolean
}>()

const emit = defineEmits<{
	googleLogin: [void]
	sendSms: [phone: string]
	sendCode: [code: string[], phone: string]
}>()

const counter = useCountdown(60)
const phoneNumber = ref<string>("")
const currentView = ref<"login" | "phone" | "otp">("login")

function onPhoneFormOpen() {
	currentView.value = "phone"
}

function onPhoneSubmit(phone: string) {
	if (props.phoneLoading)
		return

	emit("sendSms", phone)
	currentView.value = "otp"
	counter.start()
}

function onOtpSubmit(otp: string[]) {
	if (props.codeLoading)
		return

	emit("sendCode", otp, phoneNumber.value)
}

function onBack() {
	currentView.value = "phone"
}

function onGoogleLogin() {
	if (props.googleLoading)
		return
	emit("googleLogin")
}

function resendSms() {
	if (counter.isCounting.value || props.phoneLoading)
		return

	onPhoneSubmit(phoneNumber.value)
}
</script>

<template>
	<div class="h-1 min-h-screen w-screen flex flex-col *:h-full md-h-auto md:min-h-auto md:w-auto">
		<FadeTransition>
			<LoginCard
				v-if="currentView === 'login'"
				:google-loading="googleLoading"
				@phone-form="onPhoneFormOpen"
				@google-login="onGoogleLogin" />

			<PhoneForm
				v-else-if="currentView === 'phone'"
				v-model="phoneNumber"
				:loading="phoneLoading"
				@submit="onPhoneSubmit" />

			<OTPForm
				v-else-if="currentView === 'otp'"
				:phone-number="phoneNumber"
				:loading="codeLoading"
				:is-counting="counter.isCounting.value"
				:seconds="counter.seconds.value"
				@back="onBack"
				@resend-sms="resendSms"
				@submit="onOtpSubmit" />
		</FadeTransition>
	</div>
</template>
